/**
 * FAO Fisheries Division - GeoInfo viewer
 * @author Emmanuel Blondel GIS & Marine web-information systems Expert
 */
 
import $ from 'jquery'; 
window.$ = $;

//filters
import 'openfairviewer/src/import-jsonix';
import 'openfairviewer/src/import-w3c-schemas';
import 'openfairviewer/src/import-ogc-schemas';
import FilterFactory from 'openfairviewer/src/vendor/ows/FilterFactory';

//tiled layers
import {TileArcGISRest, XYZ} from 'ol/source';
import {Tile as TileLayer} from 'ol/layer';
import * as olProj from 'ol/proj';

import OpenFairViewer from 'openfairviewer/src/OpenFairViewer.js';
import './index.css';

window.OFV = null;
window.ff = null;
$(document).ready(function(){
	
	//OGC filter factory
	ff = new FilterFactory({
		version : "1.1.0",
		schemas : [CSW_2_0_2]
	});
	
	new OpenFairViewer({
		id: 'OFV',
		containerId: 'mapWrapper',
		profile : '<p>Welcome to the FAO Fisheries and Aquaculture Division <b>GeoInfo map viewer</b></p><p>This portal allows to access geographic information products maintained by the FAO Fisheries and Aquaculture division.</p>'+
		'<p><b>Usage</b>: The access to and display of spatial data is possible through an Internet based map viewer interface through which the user can in two steps Find data sets then Access the selected data.</p>'+
		'<p>Step 1. The <span style="background-color:#3EA8DF;border:2px solid #fff;padding:6px;border-radius:8px;color:white;font-size:80%;">Find</span> button on the top left opens the panel listing all available datasets. Click on the selected dataset then within it, the following options are offered:</p>'+
		'<ul style="font-size:85%;">'+
		'<li>clicking on the <span class="ai ai-doi" style="font-size:120%;color:#908b8b;"></span> icon enables to access the resource with DOI</li>'+
		'<li>clicking on the <span class="glyphicon glyphicon-info-sign" style="color:#908b8b;"></span> icon enables to access the Metadata information</li>'+
		'<li>clicking on the <span class="glyphicon glyphicon-globe" style="color:#908b8b;"></span> icon opens the <span style="background-color:#3EA8DF;border:2px solid #fff;padding:6px;border-radius:8px;color:white;font-size:80%;">Access</span> panel for Querying and Mapping.</li>'+
		'</ul>'+
		'<p>Step 2. the <span style="background-color:#3EA8DF;border:2px solid #fff;padding:6px;border-radius:8px;color:white;font-size:80%;">Access</span> panel enables to query and map or download the selected data: the query is performed by selecting one or more filters over the dataset dimensions, if any (e.g. Fishing fleet, species, fishing gear, region), the temporal extent, and - in case of statistical datasets - the aggregation method, where options are between presenting average or sum of quantities across years.<br> The map is obtained by clicking on the <span style="background-color:#3EA8DF;border:2px solid #fff;padding:4px;border-radius:8px;color:white;font-size:80%;">Query & Map</span> button.</p>'+
		'<p>The legend panel on the right gives information about the map on display including a summary of the access query performed. The map layer can be removed by clicking on the <span class="glyphicon glyphicon-remove-sign" style="color:#908b8b;"></span> icon in front of the layer title.</p>'+
		'<p>Once the resulting map is displayed, the user can access a printable version of the map or download the selected data subset, either as CSV or through dedicated reproducible scripts (R, Jupyter).</p>'+
		'<p style="font-size:80%;"><img alt="European Commission" src="https://commission.europa.eu/sites/default/files/styles/oe_theme_medium_no_crop/public/2016-08/ec-logo-horiz-web_en.jpg?itok=0cHg9HUw" height="40px" style="float: left; margin-right: 10px; "></img><em>This work has received funding from the European Union\'s Horizon 2020 research and innovation programme under Blue-Cloud (Grant Agreement No.862409).</em></p>',
		OGC_CSW_BASEURL: "https://www.fao.org/fishery/geonetwork/srv/eng/csw"
	},{	
		language: {
			auto: false,
			default: "en"
		},
		find : {
			filterByWMS: false,
			datasetInfoHandler : function(metadata){
				var datasetInfoUrl = "https://www.fao.org/fishery/geonetwork/srv/eng/catalog.search#/metadata/" + metadata.fileIdentifier;
				$('#datasetInfo').empty().html('<iframe id="'+metadata.fileIdentifier+'_gn" src="'+datasetInfoUrl+'" style="height: 100%; width: 100%; position: absolute;"> frameborder="0" marginheight="0"></iframe>');
				OFV.openInfoDialog();
			},
			facets: [
				{
					type: 'tag',
					title: 'GIS collections',
					items: [
						{
							id: 'species', 
							title: 'Aquatic species distributions', 
							color: 'white', 
							background: 'blue', 
							filter: ff.Or([
								ff.IsLike('dc:identifier', '%fao-species-map%'),
								ff.IsLike('dc:title', '%species distribution%')
							])
						},
						{
							id: 'rfb', 
							title: 'RFB Competence areas', 
							color: 'white', 
							background: 'orange', 
							filter: ff.Or([
								ff.IsLike('dc:identifier', '%fao-rfb-map%'),
								ff.IsLike('dc:title', '%competence area%')
							])
						},
						{
							id: 'vme', 
							title: 'Vulnerable Marine Ecosystems (VMEs)', 
							color: 'white', 
							background: 'lightseagreen', 
							filter: ff.IsLike('dc:identifier', '%vme%')
						},
						{
							id: 'intersection', 
							title: 'Geospatial intersections', 
							color: 'white', 
							background: 'blue', 
							filter: ff.IsLike('dc:title', '%Intersection%')
						}
					]
				},
				{
					type: 'tag',
					title: 'CWP geographic standards',
					items: [
						{
							id: 'fsa', 
							title: 'Fishery statistical areas', 
							color: 'white', 
							background: 'darkblue', 
							filter: ff.Or([
								ff.IsLike('dc:title', '%FAO Statistical Areas%'),
								ff.IsLike('dc:identifier', '%fsa%')
							])
						},
						{
							id: 'grid', 
							title: 'Grids', 
							color: 'white', 
							background: 'darkgray', 
							filter: ff.IsLike('dc:identifier', '%grid%')
						},
						{
							id: 'wja', 
							title: 'Water Jurisdiction Areas', 
							color: 'white', 
							background: 'darkgoldenrod', 
							filter: ff.IsLike('dc:identifier', '%wja%')
						}
					]
				},
				{
					type: 'tag',
					title: 'Statistics',
					items: [
						{
							id: 'catch', 
							title: 'Catches', 
							color: 'white', background: 'blue', 
							filter: ff.Or([ff.IsLike('dc:identifier', '%catch%'),ff.IsLike('dc:identifier', '%capture%'),ff.IsLike('dc:title', '%catch%'),ff.IsLike('dc:title', '%capture%')])
						},
						{
							id: 'commodities', 
							title: 'Fish Trade and Processed Products', 
							color: 'white', 
							background: 'brown', 
							filter: ff.Or([ff.IsLike('dc:identifier', '%commodities%'), ff.IsLike('dc:title', '%commodities%')])
						}
					]
				},
				{
					type: 'tag',
					title: 'Statistical collections',
					items: [
						{
							id: 'capture_production', 
							title: 'Capture production', 
							color: 'white', background: 'blue', 
							filter: ff.IsLike('dc:identifier', '%fao_global_capture%')
						},
						{
							id: 'commodity_production', 
							title: 'Commodity production', 
							color: 'white', background: 'brown', 
							filter: ff.IsLike('dc:identifier', '%fao_global_commodity%')
						}
					]
				},
				{
					type: 'tag',
					title: 'Fisheries and Resources Monitoring System (FIRMS)',
					items: [
						{
							id: 'firms',
							title: 'FIRMS Inventories',
							color: 'white', background: 'blue',
							filter: ff.And([ff.IsLike('dc:identifier', '%firms_%'), ff.IsLike('dc:identifier', '%_placemarks%')])
						},
						{
							id: 'grsf',
							title: 'GRSF',
							color: 'white', background: 'blue',
							filter: ff.IsLike('dc:identifier', '%grsf_%')
						},
						{
							id: 'gta',
							title: 'Global Tuna Atlas',
							color: 'white', background: 'blue',
							filter: ff.And([ff.IsLike('dc:title', '%tuna%'),ff.IsLike('dc:identifier', '%global_%')])
						}
					]
				},
				{
					type: 'tag',
					title: 'Regional Fisheries Organizations and Bodies (RFMOs/RFBs)',
					items: [
						{
							id: 'iccat',
							title: 'ICCAT',
							color: 'white', background: 'blue',
							filter: ff.Or([ff.IsLike('dc:subject', '%iccat%'),ff.IsLike('dc:identifier', '%iccat%')])
						},
						{
							id: 'iotc',
							title: 'IOTC',
							color: 'white', background: 'blue',
							filter: ff.Or([ff.IsLike('dc:subject', '%iotc%'),ff.IsLike('dc:identifier', '%iotc%')])
						},
					]
				}
			]
		},
		access: {
			time: 'slider',
			values_to_exclude_for: {
				aggregation_method: ['none','none_withgeom']
			},
			dashboard: {
				enabled: true
			}
		},
		map : {
			controls : {
				loadingpanel : {widget: 'progressbar'}
			},
			layer_options: {
				opacity: 0.9,
				tiled: true
			},
			zoom: 3,
			baselayers: [
				new TileLayer({
					title : "UN Clear Map (Dark)",
					type: 'base',
					source : new TileArcGISRest({							
						url: 'https://geoservices.un.org/arcgis/rest/services/ClearMap_Dark/MapServer',
						crossOrigin: 'anonymous',
						wrapX: true
					})
				}),
				new TileLayer({
					title : "UN Clear Map",
					type: 'base',
					source : new TileArcGISRest({							
						url: 'https://geoservices.un.org/arcgis/rest/services/ClearMap_WebTopo/MapServer',
						crossOrigin: 'anonymous',
						wrapX: true
					})
				}),
				new TileLayer({
					title : "World Imagery",
					type: 'base',
					source : new XYZ({
						projection: olProj.get('EPSG:4326'),
						url: 'https://wi.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
						tileSize: 256, // the tile size supported by the ArcGIS tile service
						maxResolution: 180 / 256, // Esri's tile grid fits 180 degrees on one 512 px tile
						crossOrigin: 'anonymous',
						wrapX: true
					})
				})
			],
			baselayergroup : {name: "Base maps", fold: 'open'},
			layergroups : [{name: "Datasets", fold: 'open'}],
			mainlayergroup: 0,
			/*baselayers: [
				new TileLayer({
					title : "UN Clear Map",
					type: 'base',
					source : new TileArcGISRest({							
						url: 'https://geoservices.un.org/arcgis/rest/services/ClearMap_WebTopo/MapServer',
						crossOrigin: 'anonymous',
						wrapX: true
					})
				}),
				new TileLayer({
					title : "UN Clear Map (Dark)",
					type: 'base',
					source : new TileArcGISRest({							
						url: 'https://geoservices.un.org/arcgis/rest/services/ClearMap_Dark/MapServer',
						crossOrigin: 'anonymous',
						wrapX: true
					})
				})
			],*/
			overlays: [],
			popup: {
				enabled: true
			},
			attribution :  '<img src="img/banner/fao_default.png" width="190" height="55" class="ol-powered-by" title="Food and Agriculture Organization of the United Nations" />',

		}
		
	});
	
});
